import { AsyncMultiComboBox, type ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import { getSuppliers, type GetSuppliersParams } from '../../api/clients/company.api';
import { queries } from '../../api/queryKeys/queries';
import { formatCompanyName } from '../../helpers/formatCompanyName.helper';
import type { AsyncMultiSelectProps } from '../AsyncSelectProps';

export interface SupplierCompanyMultiSelectProps extends AsyncMultiSelectProps {
    onChange: (supplierIds: string[]) => void;
    groupId?: string;
    value: string[];
}

const loadSuppliers = async (params: GetSuppliersParams): Promise<ComboBoxOption[]> => {
    const suppliers = await getSuppliers(params);

    return suppliers.map((company) => ({
        value: company.id,
        label: formatCompanyName({
            company,
        }) as ComboBoxOption['label'],
    }));
};

export function SupplierCompanyMultiSelect({ groupId, value, onChange, ...rest }: SupplierCompanyMultiSelectProps) {
    return (
        <AsyncMultiComboBox
            {...rest}
            value={value}
            onChange={onChange}
            optionsQueryKey={(search) => queries.suppliers.comboBoxOptions({ searchQuery: search, groupId }).queryKey}
            optionsQueryFn={(search) => loadSuppliers({ searchQuery: search, groupId })}
            selectedOptionsQueryKey={(values) => queries.suppliers.comboBoxOptions({ ids: values }).queryKey}
            selectedOptionsQueryFn={(values) => loadSuppliers({ ids: values })}
        />
    );
}
